"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALE = exports.DEFAULT_LOCALE = void 0;
var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en-US';
// Use `navigator.language` for dynamic locale
var LOCALE = exports.LOCALE = navigator.language || DEFAULT_LOCALE;
//# sourceMappingURL=locale.js.map